import CrudCustom from '../../../libs/custom/CrudCustom';

let StatusPajakPembeliService = new CrudCustom('/status-pajak-pembelis');
export default StatusPajakPembeliService;
